import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import scormAPI from '../scorm';

export const Menu = ({ isMenuNav, onFechar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("aba1");
  const [checkedItems, setCheckedItems] = useState(() => {
    const saved = localStorage.getItem("Hidrossanitario");
    return saved ? JSON.parse(saved) : {};
  });

  // Função para finalizar o curso via SCORM
  const finalizado = () => {
    if (typeof scormAPI === "undefined" || !scormAPI.getValue) {
      console.error("SCORM API não está ativa, não é possível finalizar a lição.");
      return;
    }

    console.log("SCORM ainda está ativo, tentando salvar progresso...");

    scormAPI.setValue("cmi.core.lesson_status", "completed");
    scormAPI.commit();

    setTimeout(() => {
      scormAPI.terminate(); // Termina a sessão após o commit
      console.log("Curso finalizado com sucesso!");
    }, 1000);
  };

  // Atualiza aba ativa com base na rota
  useEffect(() => {
    if (location.pathname === "/lesson") setActiveTab("aba1");
    else if (location.pathname === "/lesson2") setActiveTab("aba2");
    else if (location.pathname === "/lesson3") setActiveTab("aba3");
  }, [location.pathname]);

  // Salva progresso no localStorage
  useEffect(() => {
    localStorage.setItem("Hidrossanitario", JSON.stringify(checkedItems));
  }, [checkedItems]);

  // Scroll para o topo ao mudar de rota
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const finalizouRef = useRef(false);

  // Observa seções visíveis e marca como vistas
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;

        if (entry.isIntersecting) {
          setCheckedItems((prev) => {
            // evita recriar objeto se já estava marcado
            if (prev[id]) return prev;

            const updated = { ...prev, [id]: true };

            // --- Só verifica finalização se estiver na última aba ---
            if (activeTab === "aba3" && !finalizouRef.current) {
              const totalUltima = document.querySelectorAll(`article[id^="l3id"]`).length;
              const vistosUltima = Object.keys(updated).filter((k) => k.startsWith("l3id")).length;
              
              if (vistosUltima === totalUltima) {
                finalizouRef.current = true;
                finalizado(); 
              }
            }

            return updated;
          });
        }
      });
    },
    { threshold: 0.5 }
  );

  const sectionPrefix =
    activeTab === "aba1" ? "l1id"
    : activeTab === "aba2" ? "l2id"
    : "l3id";

  const allSections = document.querySelectorAll(`article[id^="${sectionPrefix}"]`);
  allSections.forEach((sec) => observer.observe(sec));

  return () => {
    allSections.forEach((sec) => observer.unobserve(sec));
  };
}, [activeTab]);

  // Detecta quando todas as seções da última aba foram visualizadas
  useEffect(() => {
    const totalSections = 9; // total de seções do módulo 3
    const viewedSections = Object.keys(checkedItems).filter((id) =>
      id.startsWith("l3id")
    ).length;

    if (viewedSections === totalSections) {
      console.log("Todas as seções foram visualizadas. Disparando finalização SCORM...");
      finalizado();
    }
  }, [checkedItems]);

  const smoothScroll = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").replace("#", "");
    const section = document.getElementById(targetId);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  const goToRoute = (path) => {
    navigate(path);
  };

  return (
    <div className={isMenuNav ? "menuRow" : "menuColumn"}>
      <button className="menu-btn-close" onClick={onFechar}>
        X
      </button>
      <h1 className="title-menu">Projeto <br />Hidrosanitário</h1>

      {/* Tabs */}
      <div className="tabs">
        <button
          onClick={() => goToRoute("/lesson")}
          className={activeTab === "aba1" ? "tab active" : "tab"}
        >
          Módulo 1
        </button>
        <button
          onClick={() => goToRoute("/lesson2")}
          className={activeTab === "aba2" ? "tab active" : "tab"}
        >
          Módulo 2
        </button>
        <button
          onClick={() => goToRoute("/lesson3")}
          className={activeTab === "aba3" ? "tab active" : "tab"}
        >
          Módulo 3
        </button>
      </div>

      {/* Conteúdo das abas */}
      {activeTab === "aba1" && (
        <ul
          className={`${isMenuNav ? "horizontal" : "vertical"} ulMenu scroll-menu height-ul`}
          style={{ maxHeight: "500px", overflow: "auto" }}
        >
          <li href="#l1id1" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l1id1"]} className="custom-checkbox" />
            <a className="menuOptions">Apresentação</a>
          </li>
          <li href="#l1id2" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l1id2"]} className="custom-checkbox" />
            <a className="menuOptions">Fundamentos para Elaboração de Projetos Hidrossanitários em Bim</a>
          </li>
          <li href="#l1id3" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l1id3"]} className="custom-checkbox" />
            <a className="menuOptions">Preparação do Ambiente de Modelagem: Primeiros Passos no Software</a>
          </li>
          <li href="#l1id4" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l1id4"]} className="custom-checkbox" />
            <a className="menuOptions">Templates: Organizando o Trabalho e a Documentação Técnica</a>
          </li>
        </ul>
      )}

      {activeTab === "aba2" && (
        <ul
          className={`${isMenuNav ? "horizontal" : "vertical"} ulMenu scroll-menu height-ul`}
          style={{ maxHeight: "630px", overflow: "auto" }}
        >
          <li href="#l2id1" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l2id1"]} className="custom-checkbox" />
            <a className="menuOptions">Apresentação</a>
          </li>
          <li href="#l2id2" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l2id2"]} className="custom-checkbox" />
            <a className="menuOptions">Inserção e Vínculos de Arquivos</a>
          </li>
          <li href="#l2id3" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l2id3"]} className="custom-checkbox" />
            <a className="menuOptions">Componentes do Modelo</a>
          </li>
          <li href="#l2id4" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l2id4"]} className="custom-checkbox" />
            <a className="menuOptions">Componentes dos Sistemas de Instalação Hidrossanitária</a>
          </li>
          <li href="#l2id5" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l2id5"]} className="custom-checkbox" />
            <a className="menuOptions">Modelagem e Modificação de Sistemas de Tubulação</a>
          </li>
        </ul>
      )}

      {activeTab === "aba3" && (
        <ul
          className={`${isMenuNav ? "horizontal" : "vertical"} ulMenu scroll-menu height-ul`}
          style={{ maxHeight: "630px", overflow: "auto" }}
        >
          <li href="#l3id1" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id1"]} className="custom-checkbox" />
            <a className="menuOptions">Apresentação</a>
          </li>
          <li href="#l3id2" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id2"]} className="custom-checkbox" />
            <a className="menuOptions">Criação e Configuração de Esgotamento Sanitário</a>
          </li>
          <li href="#l3id3" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id3"]} className="custom-checkbox" />
            <a className="menuOptions">Uso de Filtros e Modelos de Vista</a>
          </li>
          <li href="#l3id4" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id4"]} className="custom-checkbox" />
            <a className="menuOptions">Editor do Sistema</a>
          </li>
          <li href="#l3id5" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id5"]} className="custom-checkbox" />
            <a className="menuOptions">Alteração de Solução de Rota</a>
          </li>
          <li href="#l3id6" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id6"]} className="custom-checkbox" />
            <a className="menuOptions">Isolamento de Tubulação</a>
          </li>
          <li href="#l3id7" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id7"]} className="custom-checkbox" />
            <a className="menuOptions">Identificadores e Planta de Detalhes</a>
          </li>
          <li href="#l3id8" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id8"]} className="custom-checkbox" />
            <a className="menuOptions">Documentação Técnica do Projeto</a>
          </li>
          <li href="#l3id9" onClick={smoothScroll} className="menuItem">
            <input type="checkbox" readOnly checked={!!checkedItems["l3id9"]} className="custom-checkbox" />
            <a className="menuOptions">Plotagem e Impressão do Projeto</a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Menu;